/* eslint-disable react/no-array-index-key */
import React from 'react'
import moment from 'moment'

import { Expansible } from 'components/Expansible'
import { BGC_FIELDS, SCORE_PARTICIPANTS } from 'utils/constants/bgcFields'
import { AccessTime, Cancel, CheckCircle } from '@mui/icons-material'
import styles from './styles'
import BuildCompanyData from './BuildCompanyData'
import BuildFamilyRelations from './BuildFamilyRelations'
import BuildProcesses from './BuildProcesses'
import BuildRestrictions from './BuildRestrictions'
import BuildPep from './BuildPep'
import BuildNegativeMedia from './BuildNegativeMedia'
import BuildComplianceList from './BuildComplianceList'
import BuildScoreData from '../ReferenceCheck/BuildScoreData'
import BuildFinancialPendings from '../ReferenceCheck/BuildFinancialPendings'

const BgcExpansible = ({ field, bgc_info, score_data, inDenyList }) => {
  const classes = styles()

  const getTitle = () => {
    switch (field) {
      case BGC_FIELDS.job_role:
        return 'Senioridade'
      case BGC_FIELDS.occupation_area:
        return 'Especialidade'
      case BGC_FIELDS.negative_media:
        return 'Mídia Negativa'
      case BGC_FIELDS.pep:
        return 'PEP'
      case BGC_FIELDS.restriction_data:
        return 'Listas Restritivas'
      case BGC_FIELDS.process_data:
        return 'Processos Judiciais'
      case BGC_FIELDS.family_relation_data:
        return 'Vínculos Familiares'
      case BGC_FIELDS.company_data:
        return 'Participações Societárias'
      case BGC_FIELDS.compliance_list:
        return 'Compliance List'
      case BGC_FIELDS.credit_score_data:
        return 'Score de Crédito (QUOD)'
      case BGC_FIELDS.financial_pendings_data:
        return 'Pendências Financeiras'
      default:
        return null
    }
  }

  const getStatusIcon = () => {
    if (inDenyList) {
      return <Cancel style={{ color: 'red', marginRight: 5 }} />
    }

    if (!field) {
      return null
    }
    const status = bgc_info?.status || score_data?.status
    const has_issues = bgc_info?.has_issues !== null ? bgc_info?.has_issues : score_data?.has_issues
    switch (status) {
      case 'PROCESSING':
        return <AccessTime />
      case 'PROCESSED':
        if (has_issues === true) {
          return <Cancel style={{ color: 'red', marginRight: 5 }} />  
        }
        return <CheckCircle style={{ color: '#000', marginRight: 5 }} />
      default:
        return null
    }
  }
  const sectionTitle = getTitle()
  if (sectionTitle === null) {
    return null

  }
  return (
    <Expansible open={false}  title={sectionTitle} titleIcon={getStatusIcon()}>
      {bgc_info ? (
        <div
          className={
            field === BGC_FIELDS.negative_media ? classes.midia : classes.info
          }
        >
          {field === BGC_FIELDS.negative_media && (
            <BuildNegativeMedia negativeMediaData={bgc_info} />
          )}

          {field === BGC_FIELDS.pep && <BuildPep pepData={bgc_info} />}

          {field === BGC_FIELDS.restriction_data && (
            <BuildRestrictions restrictionsData={bgc_info} />
          )}

          {field === BGC_FIELDS.process_data && (
            <BuildProcesses processData={bgc_info} />
          )}

          {field === BGC_FIELDS.family_relation_data && (
            <BuildFamilyRelations familyRelationsData={bgc_info} />
          )}

          {field === BGC_FIELDS.company_data && (
            <BuildCompanyData companyData={bgc_info} />
          )}

          {field === BGC_FIELDS.compliance_list && (
            <BuildComplianceList complianceListData={bgc_info} />
          )}
          {field === BGC_FIELDS.credit_score_data && (
            <BuildScoreData score_data={bgc_info} />
          )}
          {
            field === BGC_FIELDS.financial_pendings_data && (
              <BuildFinancialPendings financialPendingsData={bgc_info} />
            
          )}

          <div className={classes.score}>
            {(!inDenyList && SCORE_PARTICIPANTS.includes(field)) ? (
              <div>
                <strong>Pontuação parcial: </strong>
                {`
                      ${
                        score_data && score_data.value ? score_data.value : 0
                      } pontos`}
              </div>
            ) : (
              <div />
            )}

            <span>
              <strong>Última atualização: </strong>{' '}
              {bgc_info.updated
                ? moment(bgc_info.updated).format('DD/MM/YYYY HH:MM')
                : 'N/A'}
            </span>
          </div>
        </div>
      ) : (
        <div className={classes.expansibleContent}>
          <span>Nenhuma informação encontrada.</span>
        </div>
      )}
    </Expansible>
  )
}

export default BgcExpansible
